var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('hr'),_c('p',{attrs:{"align":"center"}},[_vm._v("DAS | Departamento di Asunto Social – Aruba - Loket Digital")])])}
var staticRenderFns = []

export { render, staticRenderFns }